import {AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Text} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import React, {useMemo} from 'react'
import PropTypes from 'prop-types'

/**
 * Accordion item to display filter options
 * @param {object} [accordionItemProps] - props to pass to the accordion item
 * @param children - the filter options to display inside the accordion
 * @param {number} [count] - the number of selected items in the filter to display in the title
 * @param {string} [label] - the label of the filter to display in the title appended with the selected items count
 * @param {string} [title] - title to use instead of generating one from the label and count
 * @returns {JSX.Element}
 * @constructor
 */
const FilterAccordionItem = ({accordionItemProps, children, count, label, title}) => {
    const {formatMessage} = useIntl()

    const displayTitle = useMemo(() => {
        if (title) {
            return title
        }
        return formatMessage(
            {
                id: `global.filter_and_sort.accordion.title_with_count`,
                defaultMessage: '{label} {count}'
            },
            {
                count: count ? (
                    <Text as="span" color="stokkeGray.accessibleText">
                        ({count})
                    </Text>
                ) : (
                    ''
                ),
                label
            }
        )
    }, [count, formatMessage, label, title])

    return (
        <AccordionItem {...accordionItemProps} data-testid="accordion-item">
            <AccordionButton>
                <Text>{displayTitle}</Text>
                <AccordionIcon />
            </AccordionButton>
            <AccordionPanel>{children}</AccordionPanel>
        </AccordionItem>
    )
}

FilterAccordionItem.propTypes = {
    accordionItemProps: PropTypes.object,
    children: PropTypes.node,
    count: PropTypes.number,
    label: PropTypes.string,
    title: PropTypes.string
}

export default FilterAccordionItem
